module.exports = __webpack_public_path__ + "img/sayu.115df0ec.webp";